import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import PropTypes from "prop-types";

/**
 * reCAPTCHA v2 (Checkbox version)
 *
 * ✔ Shows tick checkbox
 * ✔ Google may show image challenge if needed
 * ✔ Works with Formik
 *
 * Props:
 * - siteKey (string) → REQUIRED
 * - onChange (function) → returns token
 * - onExpired (function) → token expire
 * - onError (function) → error handling
 */

const ReCaptcha = ({
  siteKey,
  onChange,
  onExpired,
  onError,
  className = "",
}) => {
  return (
    <div className={className}>
      <ReCAPTCHA
        sitekey={siteKey}
        onChange={token => {
          // token null bhi aa sakta hai
          onChange(token || "");
        }}
        onExpired={() => {
          onExpired && onExpired();
        }}
        onErrored={() => {
          onError && onError();
        }}
        theme="light"
        size="normal" // ✅ checkbox (tick mark)
      />
    </div>
  );
};

ReCaptcha.propTypes = {
  siteKey: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onExpired: PropTypes.func,
  onError: PropTypes.func,
  className: PropTypes.string,
};

export default ReCaptcha;
